import React from 'react'
// import MiniDrawer from '../../Component/newNavBarCM/newNavBar';
import Layout from '../../NewComponent/LayoutAdmin/Layout';
import Index from '../../Component/Admin/ManageUsers';
export default function AdminHome() {
  return (
    <>
    <Layout>
      <Index/>
    </Layout>
    </>
  )
}
